import { effects } from 'redux-saga'

import { begin, end, receiveError } from '../../modules/loading'
import { receiveServices } from '../../modules/service/reducer'
import callWithHmac from '../effects/callWithHmac'

export default function* load(invocation, action) {
  const ids = action.payload.serviceIds

  try {
    yield effects.put.resolve(begin('service', ids))

    const result = yield effects.call(
      callWithHmac,
      invocation.getServices,
      ids,
    )

    yield effects.put.resolve(receiveServices(result.services))
  } catch (e) {
    if (!e.response || e.response.status >= 500) {
      throw e
    }

    yield effects.put.resolve(receiveError('service', ids, e))
  } finally {
    yield effects.put.resolve(end('service', ids))
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/service/load.js